module.exports = __webpack_public_path__ + "img/section4_img3.15236e67.svg";